import {
  useCrearObjeto,
  useEditarObjeto,
  useEliminarObjeto,
  useListarObjetosTabla,
} from "../../../../Hooks/Admin";
import { CustomTable } from "../../../../Components/Admin/CustomTable";
import {
  camposFormulario,
  columns,
  formatData,
  camposFilter,
} from "./camposFormulario";

export const ObjetosEditar = () => {
  return (
    <CustomTable
      camposFilter={camposFilter}
      camposFormularioModal={camposFormulario}
      queryListar={useListarObjetosTabla}
      queryEditar={useEditarObjeto}
      formatData={formatData}
      columns={columns}
      editable={true}
      imagen={true}
      camposAgregar={camposFormulario}
      queryCrear={useCrearObjeto}
      canDelete={true}
      queryBorrarFila={useEliminarObjeto}
    />
  );
};
